import { useMemo } from "react";

export default function useQueryParams() {
  const urlParams = new URLSearchParams(location.search);

  const params = useMemo(() => Object.fromEntries(urlParams), [urlParams]);

  return params;
}
